import { MUSIC } from '../types';
export default {
  type: MUSIC,
  service: 'musicoin.org',
  url: 'https://mcdnode.trustfarm.io/api',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
